export enum DifferenceStatusType {
    NONE,
    CREATED,
    UPDATED,
    DELETED,
}

export const differenceStatusSetType = [
    'None',
    'Created',
    'Updated',
    'Deleted',
];
